import script from "./ChatPlanConfigModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPlanConfigModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatPlanConfigModal.vue?vue&type=style&index=0&id=74de4b16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74de4b16"]])

export default __exports__